<template>
  <div class="zflb-container">
    <el-row class="tcf-row">
      <el-col class="card">
        <div class="card-body">
          <el-form :inline="true" size="small" @submit.native.prevent>
            <el-form-item label="搜索关键字">
              <el-input v-model="search" placeholder="请输入关键字" @keyup.enter.native="Search" />
            </el-form-item>
            <el-form-item>
              <el-button icon="el-icon-search" @click="Search">搜索</el-button>
            </el-form-item>
          </el-form>
          <div class="card-content">
            <el-row>
              <el-col v-loading="loading">
                <el-table
                  :data="tableData"
                  :row-style="{cursor: 'pointer'}"
                  stripe
                  style="width: 100%;"
                  @row-click="openDetails"
                >
                  <el-table-column
                    label="客户名称"
                    width="140"
                    show-overflow-tooltip
                  >
                    <template slot-scope="scope">
                      <span style="color:#000;margin-right: 10px">{{ scope.row.name }}</span>
                      <svg-icon v-if="scope.row.sex === 1" icon-class="client_man" class="client-sex" />
                      <svg-icon v-if="scope.row.sex === 0" icon-class="client_women" class="client-sex" />
                    </template>
                  </el-table-column>
                  <el-table-column
                    label="微信"
                    width="140"
                    show-overflow-tooltip
                    align="center"
                  >
                    <template slot-scope="scope">
                      <span>{{ scope.row.wchat }}</span>
                    </template>
                  </el-table-column>
                  <el-table-column
                    label="联系电话"
                    width="140"
                    show-overflow-tooltip
                    align="center"
                  >
                    <template slot-scope="scope">
                      <span>{{ scope.row.tel }}</span>
                    </template>
                  </el-table-column>
                  <el-table-column
                    label="客户地区"
                    width="200"
                    show-overflow-tooltip
                  >
                    <template slot-scope="scope">
                      <span>{{ scope.row.province }} {{ scope.row.city }} {{ scope.row.county }}</span>
                    </template>
                  </el-table-column>
                  <el-table-column
                    label="客户地址"
                    width="200"
                    show-overflow-tooltip
                    align="center"
                  >
                    <template slot-scope="scope">
                      <span>{{ scope.row.address }}</span>
                    </template>
                  </el-table-column>
                  <el-table-column
                    label="作废原因"
                    show-overflow-tooltip
                    align="left"
                    min-width="200"
                  >
                    <template slot-scope="scope">
                      <span>{{ scope.row.rson }}</span>
                    </template>
                  </el-table-column>
                </el-table>
                <el-pagination
                  v-if="total>0"
                  background
                  :current-page="currentPage"
                  :page-sizes="[20, 50, 100]"
                  :page-size="pageSize"
                  layout="total, sizes, prev, pager, next, jumper"
                  :total="total"
                  @size-change="handleSizeChange"
                  @current-change="handleCurrentChange"
                />
              </el-col>
            </el-row>
          </div>
        </div>
      </el-col>
    </el-row>
  </div>
</template>

<script>
import { getUser } from '@/utils/auth'
import { getDelClientList } from '@/api/dealer'

export default {
  name: 'delzflb',
  data() {
    return {
      search: '',
      loading: false,
      tableData: [],
      currentPage: 1,
      pageSize: 20,
      total: 0
    }
  },
  computed: {
    user: getUser
  },
  created() {
    this.getData()
  }, methods: {
    openDetails(row) {
      this.$router.push({ path: '/work/delclient/' + row.cid })
    },
    Search() {
      if (this.search != null && this.search.trim() !== '') {
        this.currentPage = 1
        this.getData()
      } else {
        this.search = ''
        this.getData()
      }
    },
    getData() {
      this.loading = true
      const data = {
        mark: 0,
        search: this.search,
        page: this.currentPage,
        limit: this.pageSize,
        delid: this.user.delid,
        userid: this.user.userid
      }
      getDelClientList(data).then(response => {
        this.loading = false
        this.tableData = response.data
        this.total = response.total
      }).catch(() => {
        this.loading = false
      })
    },
    handleSizeChange(val) {
      this.pageSize = val
      this.getData()
    },
    handleCurrentChange(val) {
      this.currentPage = val
      this.getData()
    }
  }}
</script>

<style lang="scss" scoped>
  .zflb-container{
    .group-container{
      width: 100%;
      position: relative;
      padding: 20px;
      .group-item{
        position: relative;
        padding: 9px 15px;
        background: #FFF;
        border: 1px dashed #DCDFE6;
        border-radius: 4px;
        display: inline-block;
        color: #606266;
        font-size: 12px;
        font-weight: 500;
        margin:0 20px 20px 0;
        .group-del{
          padding: 2px!important;
          font-size: 10px!important;
          position: absolute;
          right: -10px;
          top: -6px;
        }
      }
    }
    .tcf-row{
      .card{
        .card-body{
          .card-title{
            .search-mode{
              width: 300px;
              position: relative;
              float: right;
              margin-top: -10px;
              .search-input{
                background-color: #F2F6FC;
                border:0;
                height: 40px;
                line-height: 40px;
                border-radius: 4px;
                color: #606266;
                padding: 0 40px 0 15px;
                -webkit-appearance: none;
                font-size: 12px;
                width: 100%;
                -webkit-box-sizing: border-box;
                box-sizing: border-box;
                outline: 0;
                &::-webkit-input-placeholder {
                  color: #C0C4CC;
                }
                &::-ms-input-placeholder {
                  color: #C0C4CC;
                }
              }
              .search-btn{
                position: absolute;
                right: 0;
                height: 40px;
                width: 40px;
                line-height: 40px;
                top: 0;
                border: 0;
                background: transparent;
                text-align: center;
                padding: 0;
              }
            }
          }
          .card-content{
            .group-filter{
              width: 100%;
              padding: 0 30px 0 0 ;
              margin: 0 ;
              position: relative;
              li{
                width: 100%;
                list-style: none;
                position: relative;
                padding-left: 20px;
                padding-top: 15px;
                padding-bottom: 15px;
                cursor: pointer;
                border-radius: 2px;
                text-overflow: ellipsis;
                overflow: hidden;
                white-space: nowrap;
                &.active{
                  background: #f5f7fa;
                  color:#409EFF;
                }
                &:hover{
                  color:#409EFF;
                }
              }
            }
            .client-sex{
              width: 16px!important;
              height: 16px!important;
              vertical-align: -4px!important;
            }
            .el-table::before{
              height: 0!important;
            }
            .el-pagination{
              margin-top: 20px;
            }
          }
        }
      }
    }
  }
</style>
